import {
  ORDER_INQUIRY_KIND_LABELS,
  ORDER_INQUIRY_KINDS,
  type OrderInquiryKind,
} from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { cn } from '@/shared/ui';

interface OrderInquiryKindFieldProps {
  readonly value: OrderInquiryKind | null;
  readonly onChange: (kind: OrderInquiryKind) => void;
}

export const OrderInquiryKindField = ({
  value,
  onChange,
}: OrderInquiryKindFieldProps): ReactElement => (
  <fieldset className="grid grid-cols-2 gap-3 sm:grid-cols-4">
    <legend className="sr-only">문의 종류</legend>
    {ORDER_INQUIRY_KINDS.map((kind) => (
      <label
        key={kind}
        className={cn(
          'flex h-12 cursor-pointer items-center justify-center rounded-xl border border-input text-[15px] font-medium transition-colors has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-foreground',
          value === kind ? 'border-foreground' : 'hover:border-foreground/50',
        )}
      >
        <input
          type="radio"
          name="order-inquiry-kind"
          aria-label={ORDER_INQUIRY_KIND_LABELS[kind]}
          checked={value === kind}
          onChange={() => onChange(kind)}
          className="sr-only"
        />
        {ORDER_INQUIRY_KIND_LABELS[kind]}
      </label>
    ))}
  </fieldset>
);
